import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerByEmail } from 'src/app/data/models';

@Component({
    selector: 'app-customer-item',
    template: `
    <div class="d-flex justify-content-between align-items-center py-1">
      <div class="d-flex flex-column">
        <span class="fs-5" i18n>Kunde auswählen</span>
      </div>
      <button type="button"
              *ngIf="!readonly"
              class="btn btn-rounded-icon btn-light-info me-2 flex-shrink-0" (click)="attachCustomer.emit()">
        <span class="material-icons md-24">edit</span>
      </button>
    </div>
  `,
    styles: [`
  `],
    standalone: false
})
export class CustomerItemComponent {
  @Input() customer: CustomerByEmail | undefined;
  @Input() readonly = false;
  @Output() attachCustomer: EventEmitter<void> = new EventEmitter<void>();
}
